import * as React from 'react';
import { PlusCircleIcon } from '@heroicons/react/24/outline';
import {
  Button,
  FormElement,
  Grid,
  Input,
  Modal,
  Text,
} from '@nextui-org/react';
import { AppLoadingButton } from '@src/layouts/app/AppLoadingButton';

interface AppModalCreateNewButtonProps {
  isOnOkLoading: boolean;
  newText: string;
  okText: string;
  onOk: (value: string) => void;
  placeholder: string;
  title: string;
}

/**
 * @name AppModalCreateNewButton
 * @description tbd...
 */
export function AppModalCreateNewButton(props: AppModalCreateNewButtonProps) {
  const { isOnOkLoading, newText, okText, onOk, placeholder, title } = props;

  // Hooks
  const [visible, setVisible] = React.useState(false);
  const [value, setValue] = React.useState('');
  const inputRef = React.useRef<FormElement>(null);

  // Handlers
  const clearAndClose = () => {
    setValue('');
    setVisible(false);
  };

  const onOkLocal = () => {
    onOk(value.trim());
    clearAndClose();
  };

  return (
    <>
      <AppLoadingButton
        auto
        loading={isOnOkLoading}
        onClick={() => setVisible(true)}
        icon={<PlusCircleIcon width={20} height={20} />}
      >
        {newText}
      </AppLoadingButton>
      <Modal
        blur
        preventClose
        aria-labelledby="modal-title"
        open={visible}
        onClose={() => clearAndClose()}
        onOpen={() => {
          setTimeout(() => {
            inputRef.current?.focus();
          }, 1);
        }}
      >
        <Modal.Header>
          <Text id="modal-title" size={18} b>
            {title}
          </Text>
        </Modal.Header>
        <Modal.Body>
          <Input
            placeholder={placeholder}
            bordered
            ref={inputRef}
            onChange={(e) => setValue(e.target.value)}
            value={value}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onOkLocal();
              }
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Grid.Container gap={1}>
            <Grid xs={6} justify="center">
              <Button
                auto
                light
                color="error"
                css={{ w: 'stretch' }}
                onPress={() => clearAndClose()}
              >
                Cancel
              </Button>
            </Grid>
            <Grid xs={6} justify="center">
              <Button auto css={{ w: 'stretch' }} onPress={() => onOkLocal()}>
                {okText}
              </Button>
            </Grid>
          </Grid.Container>
        </Modal.Footer>
      </Modal>
    </>
  );
}
